// import axios from 'axios'
// import store from '../store'

const state = {
  website: 'https://www.goldcoastnannies.company/',
  platformURL: 'https://goldcoastnannies.enginehire.io/',
  platformLoginURL: 'https://goldcoastnannies.enginehire.io/login',
  agencyHumanName: 'Coast to Coast Nannies',
};

const mutations = {

};

const actions = {

};

const getters = {
  website (state) {
    return state.website
  },
  platformURL (state) {
    return state.platformURL
  },
  platformLoginURL (state) {
    return state.platformLoginURL
  },
  agencyHumanName (state) {
    return state.agencyHumanName
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/agency.js